import { render, staticRenderFns } from "./AmsProduct.vue?vue&type=template&id=d7cfc6dc"
import script from "./AmsProduct.vue?vue&type=script&lang=js"
export * from "./AmsProduct.vue?vue&type=script&lang=js"
import style0 from "./AmsProduct.vue?vue&type=style&index=0&id=d7cfc6dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports